import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Scale } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) {
        navigate("/", { replace: true });
        return;
      }
      const session_id = m[1];
      try {
        const r = await http.post("/auth/session", { session_id });
        setUser(r.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        console.error(e);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 text-stone-900">
      <div className="flex flex-col items-center gap-4">
        <Scale className="w-8 h-8 animate-pulse text-gold-600" strokeWidth={1.5} />
        <p className="text-sm text-stone-500">Autenticando…</p>
      </div>
    </div>
  );
}
